import { render } from "./DateQuestion.vue?vue&type=template&id=d0953ec6"
import script from "./DateQuestion.vue?vue&type=script&lang=ts"
export * from "./DateQuestion.vue?vue&type=script&lang=ts"

import "./DateQuestion.vue?vue&type=style&index=0&id=d0953ec6&lang=scss"
script.render = render

export default script